/**
 * Session locale du poste.
 *
 * Le jeton vit 12 h (cf. `SESSION_TTL_MS.desktop`) : le poste du salon est
 * partage et physiquement accessible, il doit se redemander une connexion
 * chaque matin.
 *
 * NOTE securite : `localStorage` est lisible par tout script de la webview.
 * C'est acceptable ici — l'application ne charge que son propre code, et le
 * CSP de Tauri interdit tout script distant. A migrer vers le trousseau
 * systeme (`@tauri-apps/plugin-stronghold`) si l'app ouvre un jour du contenu
 * tiers.
 */
const KEY = "coucou.session";

export type StoredSession = {
  token: string;
  expiresAt: string;
  user: { id: string; firstName: string; role: string; salonId: string | null };
};

export function loadSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as StoredSession;
    // Jeton perime : on nettoie plutot que d'envoyer une requete vouee a 401.
    if (new Date(session.expiresAt) <= new Date()) {
      localStorage.removeItem(KEY);
      return null;
    }
    return session;
  } catch {
    localStorage.removeItem(KEY);
    return null;
  }
}

export function saveSession(session: StoredSession) {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(KEY);
}
